/**
 * @desc 查询生料生产季度计划
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: defs.IdRequest,
): Promise<defs.StandardReturn<defs.PlanQuarterRawMealResponse>> {
  return defHttp.post({
    url: '/wap/plan/quarter/queryPlanRawMeal',
    data,
  });
}

export function mock(
  data: defs.IdRequest,
): Promise<defs.StandardReturn<defs.PlanQuarterRawMealResponse>> {
  return defHttp.post({
    url: '/mock/wap/plan/quarter/queryPlanRawMeal',
    data,
  });
}
